import { twJoin, twMerge } from "tailwind-merge";
import { useBoolean, useTimeout } from "usehooks-ts";
import { motion } from "framer-motion";

type LoaderProps = {
  size?: "small" | "large";
  /** delay display, default 300ms, set to null for no delay */
  delayMs?: number | null;
};

export const Loader = (props: LoaderProps) => {
  const { size = "large", delayMs = 300 } = props;

  const { value: delayHasPassed, setTrue } = useBoolean(!delayMs);
  useTimeout(setTrue, delayMs || null);

  const sizeClass = size === "large" ? "h-12 w-12 border-[3px]" : "h-5 w-5 border-2";

  return (
    <motion.div
      className={twJoin(
        "rounded-full border-lac-leman border-b-transparent",
        sizeClass,
        !delayHasPassed && "invisible",
      )}
      animate={{ rotate: 360, scale: [1, 1.08, 1], opacity: [0.5, 1, 0.5] }}
      transition={{
        rotate: { duration: 1.3, repeat: Infinity, ease: "linear" },
        scale: { duration: 2.4, repeat: Infinity, ease: "easeInOut" },
        opacity: { duration: 2.4, repeat: Infinity, ease: "easeInOut" },
      }}
    />
  );
};

type FillContainerLoaderProps = LoaderProps & { className?: string };

export const FillContainerLoader = (props: FillContainerLoaderProps) => {
  const { className, ...restProps } = props;
  return (
    <div className={twMerge("flex h-full w-full items-center justify-center", className)}>
      <Loader {...restProps} />
    </div>
  );
};
